var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-editor"},[(_vm.label)?_c('span',{staticClass:"code-editor__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('highlightjs',{class:['code-editor__input', { 'm-fixedHeight': _vm.fixedHeight }],attrs:{"autodetect":"","code":_vm.code}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }